<template>
<!-- 引入第二套图形验证码，是因为需要走风控 -->
  <div class="code-content">
    <div class="code-title">{{getCode}}</div>
    <div class="code-img">
        <img :src="imgSrc">
        <div class="refresh" @click="aginImgCode">{{codeRetryText}}</div>
    </div>
    <div class="code-wrapper">
      <div class="code-desc2 clear-fix">
        <span class="code-num">{{codeText}}</span>
      </div>
      <VerifyCode :num="4" type="password" @fillCb="fill" ref="vc"></VerifyCode>
    </div>
  </div>
</template>

<script type="text/javascript">
import VerifyCode from '../../../components/VerifyCode.vue'
import { getVerifyCaptchaWithCell, getCaptchaWithCell } from '../api'
import auth from 'common-js/api/auth'
import { rsaEncrypt } from 'common-js/util/tool'

export default {
  name: 'imgCode',
  components: {
    VerifyCode
  },
  data() {
    return {
      getCode: '请输入图形内验证码',
      codeRetryText: '点击刷新',
      codeText: '4位字母(不区分大小写)',
      imgSrc: ''
    }
  },
  mounted() {
    this.getCaptchaWithCellData()
  },
  methods: {
    fill(code) {
      this.getVerifyCaptchaData(code)
    },
    getCaptchaWithCellData () {
      const param = {
        ticket: auth.get('token'),
        cell: '',
        cell_encrypted: this.$route.query.cell && rsaEncrypt(this.$route.query.cell),
        risk: JSON.stringify(this.$route.query)
      }
      getCaptchaWithCell(this, param)
    },
    getVerifyCaptchaData (code) {
      const param = {
        ticket: auth.get('token'),
        cell: '',
        cell_encrypted: this.$route.query.cell && rsaEncrypt(this.$route.query.cell),
        code
      }
      getVerifyCaptchaWithCell(this, param)
    },
    clearCode() {
      this.$refs.vc.clear()
    },
    aginImgCode() {
      this.getCaptchaWithCellData()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "common-css/func.scss";
@import "common-css/mixins.scss";
.code-content {
  width: 100%;
  height: 100%;
  background: #fff;
  box-sizing: border-box;
  padding: 0 px2rem(40);
  .code-title {
    padding-top: px2rem(32);
    font-family: PingFangSC-Medium;
    font-weight: bold;
    font-size: px2rem(48);
    color: #4A4A4A;
  }
  .code-img {
    width: px2rem(400);
    height: px2rem(120);
    background: #fff;
    img {
      width: px2rem(400);
      height: px2rem(120);
      margin-top: px2rem(20);
    }
    .refresh {
      font-size: px2rem(24);
      color: #4a4c5b;
      text-align: right;
      line-height: px2rem(40);
    }
  }
  .code-wrapper {
    margin-top: px2rem(120);
    span {
      display: inline-block;
      vertical-align: middle;
    }
    .code-desc2 {
      position: relative;
      .code-num {
        float: left;
        width: 70%;
        line-height: px2rem(50);
        font-size: px2rem(28);
        color: #989898;
      }
    }
  }
}
</style>
